import { render, staticRenderFns } from "./ProfileCardStats.vue?vue&type=template&id=b283eaac&scoped=true&"
import script from "./ProfileCardStats.vue?vue&type=script&lang=js&"
export * from "./ProfileCardStats.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCardStats.vue?vue&type=style&index=0&id=b283eaac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b283eaac",
  null
  
)

export default component.exports